/**
 * Created by sivanh on 09/01/17.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var Bubble = require("ui/bubble/Bubble");
    var template = require("manager-templates/data-sources/api-keys/apiKeyIpRangeItemView.tmpl");
    var ApiKeyIpRangeItemView = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        ApiKeyIpRangeItemView = Marionette.ItemView.extend({
            template: template,
            tagName: "li",
            className: "ip-restriction-range-input-row",
            fromErrorMsg: null,
            toErrorMsg: null,
            withUIComponents:true,

            ui:{
                "ipInputFrom":".ip-input.from",
                "fromIpInputs":".ip-input.from input",
                "ipInputTo":".ip-input.to",
                "toIpInputs":".ip-input.to input"
            },

            events:{
                "click .ip-range-input-row-close-btn":"_closeIpRestrictionItem",
                "blur .ip-input.from input ":"_onFromInputBlur",
                "focus .ip-input input ":"_onInputFocus",
                "blur .ip-input input ":"_onInputBlur",

                "input .ip-input input":"_onInputChange",
                "cut .ip-input input":"_onInputChange",
                "paste .ip-input input":"_onInputChange",
                "keyup .ip-input input":"_onInputChange"

            },

            customTemplateHelpers:function () {
                var model = this.model;
                var ipFrom = {
                    A : model.getPartOfIp("from", 0),
                    B : model.getPartOfIp("from", 1),
                    C : model.getPartOfIp("from", 2),
                    D : model.getPartOfIp("from", 3)
                };

                var ipTo = {
                    A : model.getPartOfIp("to", 0),
                    B : model.getPartOfIp("to", 1),
                    C : model.getPartOfIp("to", 2),
                    D : model.getPartOfIp("to", 3)
                };

                return {
                    ipFrom:ipFrom,
                    ipTo:ipTo
                };
            },

            initialize: function (options) {
                LEManager.logger.debug("init ApiKeyIpRangeItemView","ApiKeyIpRangeItemView:initialize",options);
                this.channel = options.channel;
                this.ipRangesReadOnlyMode = options.ipRangesReadOnlyMode;
            },

            onRender: function () {
                if(this.ipRangesReadOnlyMode){
                    this.ui.fromIpInputs.prop("disabled", true);
                    this.ui.toIpInputs.prop("disabled", true);
                }
            },

            /**
             * On Blur check we have at least first 3 vals in the from and then check that the "to" fiels are empty  - then copy the values to them
             * If all ip fields of the from are full update the from model
             * @param ev
             */
            _onFromInputBlur:function (ev) {
                if (this.model.getPartOfIp("from", 0).length > 0 && this.model.getPartOfIp("from", 1).length > 0 && this.model.getPartOfIp("from", 2).length > 0 && this.model.isIpEmpty("to")) {
                    this._copyIp();
                }
            },

            _copyIp: function() {
                for (var i = 0; i < this.ui.fromIpInputs.length - 1; i++) {
                    var value = this.model.getPartOfIp("from", i);
                    if (this.model.setPartOfIp("to", i, value)) {
                        this.ui.toIpInputs.eq(i).val(value);
                    }
                }
            },

            _onInputChange:function (ev) {
                var that = this;
                var element = ev.currentTarget;
                //validate vals on paste to avoid invalid values
                setTimeout(function () { //paste value is available on the element only after timeout
                    that._updateValue(element);
                }, 0);
            },

            /**
             * Update the view value array for the ip from the dom,
             * Block unAppropriate values
             * @param element
             */
            _updateValue:function (element) {
                var $element = $(element);
                var $parent = $(element.parentNode);
                var index = $element.index();
                var valStr = element.value;

                var ipType = $parent.hasClass("from") ? "from" : "to";
                var previousValue = this.model.getPartOfIp(ipType, index);
                if (this.model.setPartOfIp(ipType, index, valStr)) {
                    this.channel.trigger("apiKey:change:ipRangesCollection", this.model);
                    if (valStr.length === 3 && index < 3 && valStr !== previousValue) {
                        $(element).next().focus();
                    }
                }
                else {
                    $element.val(previousValue);
                }
            },

            _closeIpRestrictionItem:function (ev) {
                LEManager.logger.debug("close ApiKeyIpRangeItemView clicked","ApiKeyIpRangeItemView:_closeIpRestrictionItem");
                ev.stopPropagation();
                this.trigger("close:clicked", this.model); //listenTo this event and checks when to remove the x
            },

            _onInputFocus: function(ev) {
                var element = $(ev.currentTarget);
                var parent = element.parent();

                if (parent.hasClass("from")) {
                    if (parent.hasClass("error") && this.fromErrorMsg) {
                        this._closeIpError(true);
                        this.uiComponents.host$.createAndRender("IpError", {
                            type:Bubble,
                            options:{
                                targetControl:this.ui.ipInputFrom,
                                text:this.fromErrorMsg,
                                position:Bubble.POSITION.BOTTOM,
                                icon:Bubble.ICON.ERROR,
                                showCloseButton:false
                            }
                        });
                    }
                }
                if (parent.hasClass("to")) {
                    if (parent.hasClass("error") && this.toErrorMsg) {
                        this._closeIpError(true);
                        this.uiComponents.host$.createAndRender("IpError", {
                            type:Bubble,
                            options:{
                                targetControl:this.ui.ipInputTo,
                                text:this.toErrorMsg,
                                position:Bubble.POSITION.BOTTOM,
                                icon:Bubble.ICON.ERROR,
                                showCloseButton:false
                            }
                        });
                    }
                }
            },

            _onInputBlur: function(ev) {
                var element = $(ev.currentTarget);
                var parent = element.parent();

                parent.removeClass("error");
                this._closeIpError(false);
            },

            _closeIpError: function(force){
                if (this.uiComponents.IpError) {
                    this.uiComponents.IpError.close(force);
                }
            },

            _setError: function(el) {
                el.addClass("error");
            },

            _clearError: function() {
                this.fromErrorMsg = null;
                this.toErrorMsg = null;
                this.ui.ipInputFrom.removeClass("error");
                this.ui.ipInputTo.removeClass("error");
            },

            onValidatedInvalid:function (model, errors) {
                this._clearError();

                if (_.has(errors, "from")) {
                    this._setError(this.ui.ipInputFrom);
                    this.fromErrorMsg = errors.from;
                }

                if (_.has(errors, "to")) {
                    this._setError(this.ui.ipInputTo);
                    this.toErrorMsg = errors.to ;
                }
            },

            onValidatedValid: function() {
                this._clearError();
            }

        });

    });
    return ApiKeyIpRangeItemView;
});
